import { useEffect, useState } from "react";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { useNavigate } from "react-router-dom";
import routePaths from "../../../routes/routePaths";

export default function HomeSuccessHighlightPreview() {
  const [students, setStudents] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHighlights = async () => {
      const q = query(
        collection(db, "success_highlights"),
        where("active", "==", true),
        orderBy("order", "asc")
      );
      const snap = await getDocs(q);
      const items = snap.docs.map(doc => doc.data());
      setStudents(items);
    };
    fetchHighlights();
  }, []);

  if (!students.length) return null;

  return (
    <section className="py-14 px-4 text-center bg-bg">
      <h2 className="text-2xl md:text-3xl font-extrabold mb-10 text-primary">
        {t("home.successHeading")}
      </h2>
      <div className="max-w-2xl mx-auto">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
        >
          {students.map((student, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col items-center bg-card rounded border border-border shadow-sm p-8 mx-4">
                <img
                  src={student.photoUrl}
                  alt={student.name}
                  className="rounded-full shadow-sm w-28 h-28 object-cover border-4 border-primary mb-5"
                />
                <blockquote className="italic text-menu text-lg leading-relaxed mb-2">
                  “{student.quote?.[i18n.language] || student.quote?.vi}”
                </blockquote>
                <div className="mt-1 text-sm text-primary font-bold">
                  – {student.name}, {student.grade}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button
        className="mt-10 bg-primary hover:bg-secondary text-textButton font-bold px-8 py-2 rounded shadow-sm transition text-base"
        onClick={() => navigate(routePaths.results)}
      >
        {t("home.moreResults")}
      </button>
    </section>
  );
}
